import axios from "axios"
import store from "@/store"

let baseUrl

switch (import.meta.env.MODE) {
    case 'production':
        baseUrl = 'https://mesh.multicard.uz/subscription/'
        break;
    case 'development':
        baseUrl = 'https://dev-mesh.multicard.uz/subscription/'
        break;
    default:
        baseUrl = 'http://localhost:8081/'
}

const client = axios.create({
    baseURL: baseUrl
})

client.interceptors.request.use((request) => {
    return request
})

client.interceptors.request.use(undefined, (error) => {
    console.log(error, 'error')
    const { response } = error
    const { data } = response
    if ([401, 403].includes(response.status)) {
        // const refreshToken = store.getters.refreshToken
        // if (typeof refreshToken === 'string' && refreshToken.length) {
        //     apiClient.post(`/menu/auth/refresh?token=${refreshToken}`).then(({data}) => {
        //         if (data.success) {
        //             store.dispatch("saveRefreshToken", data.data.refresh)
        //             store.dispatch("saveToken", data.data.token)
        //         }
        //     }).finally(() => {
        //         apiClient.delete(`/menu/auth/refresh?token=${refreshToken}`)
        //     })
        // }
    } else {
        alert(data.error.details || "Системная ошибка, попробуйте позже")
        // Notify({
        //     type: "warning",
        //     message: data.error.details || "Системная ошибка, попробуйте позже",
        // });
        store.dispatch("setLoading", false).then((r) => console.log(r))
    }
    return Promise.reject(data)
})

export default client
